import React from 'react';

const jokes = [
	'Hold on, moving satellites into positions..',
	'Waiting until the stars align, please wait..',
	'Making coffee, please wait..',
];

const rand = Math.floor(Math.random()*jokes.length);

const Loading = ({error,withLogo}) => (
	<div className="isLoading" style={{backgroundImage:withLogo ? 'url("/images/bg.png")':null,position:'absolute',top:0,right:0,left:0,bottom:0}}>
		<div>
			{
				withLogo
				?
					<div style={{position:'absolute',marginLeft:'auto',marginRight:'auto',left:0,right:0}}><img style={{marginTop:'-160px',width:'200px'}} src="/assets/images/logo.png"  /></div>
				:
				null
			}
			{
				error !== false
				?
				<span><i style={{fontSize:'50px'}} className="icon wb-thumb-down"></i><br /><br />This didn't go as expected. Try refreshing the page..<br />
				<strong>Message:</strong> {error}</span>
				:
				<div className="spin2win">
					<div className="double-bounce1"></div>
					<div className="double-bounce2"></div>

				</div>
			}
			{
				error !== false
				?
				null
				:
				<div style={{position:'absolute',marginLeft:'auto',marginRight:'auto',left:0,right:0}}>
					<p style={{fontWeight:'bold',marginTop:(withLogo === true ? '40px' : '30px')}}>{jokes[rand]}</p>
				</div>
			}
		</div>
	</div>
);

export default Loading;



// WEBPACK FOOTER //
// ./components/Loading.js